import React, {useState, useEffect, useContext, useRef} from 'react';
import { Route, NavLink } from "react-router-dom";
import styled from 'styled-components'
import moment from 'moment'
import Sidebar from '../dashboard/components/navigation/sidebar'
import Overview from './views/overview'
import Accounts from './views/accounts'
import Team from './views/team'
import Groups from './views/groups'
import Group from './views/group'
import Campaigns from './views/campaigns'
import Campaign from './views/campaign'
import HqChallenges from './views/hq-challenges'
import HqChallenge from './views/hq-challenge'
import Weekly from './views/weekly'
import Templates from './views/templates'
import MealEdit from './views/template/meal-edit'
import MealShare from './views/template/meal-share'
import DayEdit from './views/template/day-edit'
import DayShare from './views/template/day-share'
import Profile from './views/profile'
import Support from './views/support'
import Resources from './views/resources'
import Inspect from './views/inspect'
import Billing from './views/billing'
import Terms from './views/terms'
import Videos from './views/videos'
import { hostDateToString } from './views/inspect/util'
import { AuthContext } from '../../auth-context'
import Snackbar from './components/snackbar'
import { DashboardContext } from './dashboard-context'
import { ThemeContext } from 'styled-components'
import { ChatService } from './components/chat'
import { useLocation } from "react-router-dom";
import { loadProfile, getStreamChatToken } from '../../api'
import {
  Chat,
  useCreateChatClient,
} from "stream-chat-react";
import Surveys from './views/surveys'
import config from '../../config'
import "../../css/avn-components.sass"
// import { useSnackbar } from 'notistack'

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #f8f9fb;
`;

const Page = styled.div`
  // padding-top: 90px;
  flex: 1;
  max-height: 100vh;
  /* width: 100%; */
  overflow: auto;

  @media(max-width: 900px) {
    padding-top: 55px;
  }
`;

const BalanceLinkContainer = styled.div`
  padding: 10px;
  background: orange;
  width: 100%;
  text-align: center;
`

const BalanceLink = styled(NavLink)`
  cursor: pointer;
  color: #fff;
  padding: 5px;
`

const Dashboard = (props) => {
  const theme = useContext(ThemeContext)
  const { user, updateUser } = useContext(AuthContext);
  const { pathname } = useLocation()
  const pageRef = useRef();
  const client = useCreateChatClient({
    apiKey: (user.branch === 1) ? config.STREAMCHAT.apiKeyFBBC : config.STREAMCHAT.apiKey,
    tokenOrProvider: localStorage.getItem('streamChatToken'),
    userData: { id: `${config.STREAMCHAT.portalUserPrefix}${user.id}` },
  });
  // const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const [snackbar, updateSnackbar] = useState({
    show: false,
    message: '',
    error: false
  })
  const [filterGroupID, setFilterGroupID] = useState(0)
  const [clientsTrainerID, setClientsTrainerID] = useState((user.role_id === 1 || user.role_id === 2) ? '' : user.id)
  const [clientSearch, setClientSearch] = useState({
    searchTerm: '',
    searchType: 'Email',
  })
  const [teamSearch, setTeamSearch] = useState({
    searchTerm: '',
    searchType: 'Email',
  })
  const [showMesssages, setShowMessages] = useState(false)
  const [messageChannel, setMessageChannel] = useState('')
  const [channelFilter, setChannelFilter] = useState('')
  const [unreadChannels, setUnreadChannels] = useState(0);

   useEffect(() => {
    const interval = setInterval(() => {
      loadProfile(user.id).then((res) => {
        if (res.data.profile.active === 1) {
          updateUser(res.data.profile)
        }
      })
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (user.id) {
      getStreamChatToken(user.id).then((res) => {
        window.localStorage.setItem('streamChatUser', res.data.id)
        window.localStorage.setItem('streamChatToken', res.data.token)
        // initializeStreamChat(user.branch, res.data.token)
      }).catch((err) => {
        console.log(err)
      });
    }
  }, [user.id]);

  useEffect(() => {
    // const handleNotification = (event) => {
    //   if(Notification) {
    //     if(event.type === 'notification.message_new' && Notification) {
    //       if(!!event.message.text)
    //         new Notification(event.message.text)
    //       else if (!!event.message.attachments.length !== 0)
    //         new Notification('Attachment')
    //     }
    //   }
    // }
    const getUnread = async () => {
      const unread = await client.getUnreadCount(client.userID);
      setUnreadChannels(unread.channels.length);
    }
    
    if (client) {
      const handleEvent = event => {
        if (event.unread_channels !== undefined) {
          // handleNotification(event)
          setUnreadChannels(event.unread_channels);
        }
        // if (event.type === 'message.new') {
        //   enqueueSnackbar(event.message.user.name, { variant: 'default' })
        // }
      };
      if (client.userID) {
        getUnread();
        client.on(handleEvent);
      }
      return () => {
        if (client.userID) {
          client.off(handleEvent);
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id, client]);

  useEffect(() => {
    if(pageRef?.current)
      pageRef.current.scrollTop = 0  
  }, [pathname]);

  const openSnackbar = (message, error) => {
    updateSnackbar({
      show: true,
      message: message,
      error: error
    })
  }

  const hideSnackbar = () => {
    updateSnackbar({...snackbar, show: false})
  }

  if (!user || !client) return
  return (
    <DashboardContext.Provider
      value={{
        snackbar: snackbar,
        openSnackbar: openSnackbar,
        closeSnackbar: hideSnackbar,
        filterGroupID: filterGroupID,
        setFilterGroupID: setFilterGroupID,
        clientsTrainerID: clientsTrainerID,
        setClientsTrainerID: (val) => {
          setClientsTrainerID(val)
        },
        clientSearch: clientSearch,
        setClientSearch: setClientSearch,
        teamSearch: teamSearch,
        setTeamSearch: setTeamSearch,
        showMessages: showMesssages,
        setShowMessages: setShowMessages,
        messageChannel: messageChannel,
        setMessageChannel: setMessageChannel,
        channelFilter: channelFilter,
        setChannelFilter: setChannelFilter,
      }}
    >
      <Chat client={client}>
        <Container>
          <Sidebar unreadChannels={unreadChannels} />
          {process.env.REACT_APP_STAGE !== 'prod' &&
            <div style={{background: '#ffc700', textAlign: 'center', width: '100%', position: 'fixed', bottom: 0, left: 0, zIndex: 200, pointerEvents: 'none'}}>
              <p style={{color: '#000', fontSize: '.9rem'}}>This is the <b>{process.env.REACT_APP_STAGE}</b> environment.</p>
            </div>
          }
          <Page ref={pageRef}>
            {user.role_id === 1 && user.payment_alert_date !== null && user.balance > 0 && (
              <BalanceLinkContainer><BalanceLink to="/dashboard/billing">You have an outstanding balance of ${user.balance.toFixed(2)}. Please check your billing information.{user.payment_warning ? (user.payment_overdue ? ' Clients have now lost access.' : (' Otherwise, clients will lose access on ' + moment.utc(hostDateToString(user.payment_overdue_date) + 'T00:00:00Z').format('MMM D, YYYY') + '.')) : ''}</BalanceLink></BalanceLinkContainer>
            )}
            {/* <Header unreadChannels={props.unreadChannels} /> */}
            <Route path="/dashboard/overview" component={Overview} />
            {(user.role_id === 1 || user.role_id === 2)  && <Route path="/dashboard/accounts" component={Accounts} />}
            {(user.role_id === 1 || user.role_id === 2)  && <Route path="/dashboard/team" component={Team} />}
            {(user.role_id === 1 || user.role_id === 2)  && <Route path="/dashboard/groups" component={Groups} />}
            {(user.role_id === 1 || user.role_id === 2)  && <Route path="/dashboard/group/:id" component={Group} />}
            {(user.role_id === 1 || user.role_id === 2)  && <Route path="/dashboard/campaigns" component={Campaigns} />}
            {(user.role_id === 1 || user.role_id === 2)  && <Route path="/dashboard/campaign/:id" component={Campaign} />}
            {(user.role_id === 1 || user.role_id === 2)  && <Route path="/dashboard/hq-challenges" component={HqChallenges} />}
            {(user.role_id === 1 || user.role_id === 2)  && <Route path="/dashboard/hq-challenge/:id" component={HqChallenge} />}
            <Route path="/dashboard/forms" component={Surveys} />
            <Route path="/dashboard/weekly" component={Weekly} />
            <Route path="/dashboard/templates" component={Templates} />
            <Route path="/dashboard/template/meal-edit/:id" component={MealEdit} />
            <Route path="/dashboard/template/meal-share/:id" component={MealShare} />
            <Route path="/dashboard/template/day-edit/:id" component={DayEdit} />
            <Route path="/dashboard/template/day-share/:id" component={DayShare} />
            {user.role_id === 1 && <Route path="/dashboard/billing" component={Billing} />}
            <Route path="/dashboard/profile" component={Profile} />
            <Route path="/dashboard/support" component={Support} />
            <Route path="/dashboard/resources" component={Resources} />
            <Route path="/dashboard/videos" component={Videos} />
            <Route path="/dashboard/inspect/:id" component={Inspect} />
            <Route path="/dashboard/terms" component={Terms} />
          </Page>
        </Container>
        <Snackbar />
        <ChatService />
      </Chat>
    </DashboardContext.Provider>
  )
}

export default Dashboard